module.exports = __webpack_public_path__ + "img/jatri_stair.1578b042.svg";